import { MDXAspect } from './mdx.aspect';

export default MDXAspect;
export type { MDXMain } from './mdx.main.runtime';
export type { MDXCompilerOpts } from './mdx.compiler';
export { MdxEnv } from './mdx.env';

export { MDXAspect };
